import { Injectable } from '@angular/core';
import { WebServicesService } from '../web-services/web-services.service';
import { Page } from '../web-services/page.model';
import { User } from './user.model';
import { PagedData } from '../web-services/paged-data.model';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from '../../service/notification/notification.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class UserService {

	constructor(
		private notificationService: NotificationService,
		private translateService: TranslateService,
		private webServicesService: WebServicesService
	) { }

	/* Appels aux webServices */

	public getUsers(page?: Page, sort?: string, dir?: string): Promise<PagedData<User>> {
		console.log('RÃ©cupÃ©ration des utilisateurs');
		let promise: Promise<PagedData<User>>;
		if (page) {
			if (sort && dir) {
				promise = this.webServicesService.getList<User>('/user?size=' + page.size + '&page=' + page.number + '&sort=' + sort + ',' + dir);
			} else {
				promise = this.webServicesService.getList<User>('/user?size=' + page.size + '&page=' + page.number);
			}
		}
		else {
			promise = this.webServicesService.getList<User>('/user');
		}
		return promise
			.catch(error => {
				this.notificationService.showError(this.translateService.instant('GET_USERS_ERROR'));
				return Promise.reject(error);
			})
	}

	public postUser(user: User): Promise<User> {
		console.log('Ajout d\'un nouvel utilisateur');
		let json = {
			firstName: user.firstName,
			lastName: user.lastName,
			email: user.email,
			company: user.company,
			phone: user.phone
		}
		return this.webServicesService.post<User>('/user', json)
			.catch(error => {
				if((error instanceof HttpErrorResponse) && (error.status == 409)){
					this.notificationService.showError(this.translateService.instant('POST_PUT_USER_CONFLICT'));
				} else {
					this.notificationService.showError(this.translateService.instant('ERROR'));
				}
				return Promise.reject(error);
			})
	}

	public patchUser(user: User): Promise<User> {
		console.log('Modification de l\'utilisateur ' + user.id);
		let json = {
			firstName: user.firstName,
			lastName: user.lastName,
			email: user.email,
			company: user.company,
			phone: user.phone
		}
		return this.webServicesService.patch<User>('/user/' + user.id, json)
			.catch(error => {
				if((error instanceof HttpErrorResponse) && (error.status == 409)){
					this.notificationService.showError(this.translateService.instant('POST_PUT_USER_CONFLICT'));
				} else {
					this.notificationService.showError(this.translateService.instant('ERROR'));
				}
				return Promise.reject(error);
			})
	}

	public deleteUser(userId: string) {
		console.log('Suppression de l\'utilisateur ' + userId);
		return this.webServicesService.delete('/user/' + userId)
			.catch(error => {
				this.notificationService.showError(this.translateService.instant('ERROR'));
				return Promise.reject(error);
			})
	}
}
